/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ProducedMaterialStatus {
  None = 'None',
  Seed = 'Seed',
  Active = 'Active',
  Open = 'Open',
  Finished = 'Finished'
}
